import React, { useState } from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import IconButton from "@mui/joy/IconButton";
import Typography from "@mui/joy/Typography";
import BookmarkAdd from "@mui/icons-material/BookmarkAddOutlined";
import Button from "@mui/material/Button";
import MapIcon from "@mui/icons-material/Map";
import ErrorIcon from "@mui/icons-material/Error";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./DashListingCard.module.css";
import DashListingDetails from "../DashListingDetails/DashListingDetails";
import Map from "../../../../components/Map/Map";

import BedIcon from "@mui/icons-material/Bed";
import BathtubIcon from "@mui/icons-material/Bathtub";

import { Grid, Chip, Stack } from "@mui/material";

const DashListingCard = ({ listing }) => {
  const [detailsModel, setDetailsModel] = useState(false);

  function formatMoney(number) {
    if (typeof number === "number") {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(number);
    }
    return number;
  }

  const handleCardClick = () => {
    setDetailsModel(true);
  };

  const closeModel = () => {
    setDetailsModel(false);
  };

  const handleBookmarkClick = async (e) => {
    e.stopPropagation();
    try {
      const response = await fetch("/api/favorites", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ listingId: listing.id }),
      });

      if (response.ok) {
        toast.success("Listing added to favorites successfully!");
      } else {
        toast.error("Failed to add listing to favorites.");
      }
    } catch (error) {
      toast.error("An error occurred while adding to favorites.");
    }
  };

  const isPremium = listing.is_premium === true;

  return (
    <>
      <Card
        className={`${styles.listingContainer} ${
          isPremium ? styles.premiumCard : ""
        }`}
        variant="outlined"
        onClick={handleCardClick}
      >
        {/* Premium Badge */}
        {isPremium && <div className={styles.premiumBadge}>Premium</div>}

        <AspectRatio minHeight="120px" maxHeight="200px">
          <img
            src={listing.image_url}
            loading="lazy"
            alt={listing.address}
            className={styles.listingImage}
          />
        </AspectRatio>

        <CardContent
          className={isPremium ? styles.scrollableContent : ""}
          sx={{ overflow: "auto", maxHeight: isPremium ? "600px" : "auto" }}
        >
          {/* Title */}
          <Typography level="h5" className={styles.listingTitle}>
            {listing.title}
          </Typography>

          {/* Listing Type */}
          <Typography level="body2" className={styles.listingInfo}>
            {listing.listing_type === "1" ? "For Rent" : "For Sale"}
          </Typography>

          {/* Area, Year Built */}
          <Typography level="body2" className={styles.listingInfo}>
            {listing.area_sqft} sqft | Built in {listing.year_built}
          </Typography>

          {/* Address */}
          <Typography level="body2" className={styles.listingAddress}>
            {listing.street} {listing.street_2}, {listing.city}, {listing.state}
            , {listing.zipcode}
          </Typography>

          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
            className={styles.listingInfo}
          >
            <Chip icon={<BedIcon />} label={`${listing.bedrooms} Beds`} />
            <Chip icon={<BathtubIcon />} label={`${listing.bathrooms} Baths`} />
          </Stack>

          {/* Price */}
          <Typography level="body2" className={styles.listingPrice}>
            {listing.rent_price
              ? formatMoney(listing.rent_price) + " /mo"
              : listing.sell_price
              ? formatMoney(listing.sell_price)
              : "Price Not Available"}
          </Typography>

          {/* Additional Details for Premium Properties */}
          {isPremium && (
            <>
              <Typography level="body2" className={styles.additionalInfo}>
                Available From:{" "}
                {new Date(listing.available_from).toLocaleDateString()}
              </Typography>
              <Typography level="body2" className={styles.additionalInfo}>
                Landmark: {listing.landmark}
              </Typography>
              <Typography level="body2" className={styles.description}>
                {listing.description}
              </Typography>

              {/* Map Section */}
              <div className={styles.mapSection}>
                <div className={styles.mapSectionHeader}>
                  <MapIcon />
                  <div className={styles.mapSectionTitle}>Address</div>
                </div>

                <div className={styles.mapContainer}>
                  <Map
                    propertyData={{
                      street: listing.street || "",
                      Unit: listing.street_2 || "",
                      city: listing.city || "",
                      state: listing.state || "",
                      zipcode: listing.zipcode || "",
                      address: `${listing.street || ""} ${
                        listing.street_2 || ""
                      }, ${listing.city || ""}, ${listing.state || ""} ${
                        listing.zipcode || ""
                      }`,
                    }}
                  />
                </div>

                {/* {listing.hide_address !== true ? (
                  <div className={styles.mapContainer}>
                    <Map propertyData={{
                      street: listing.street || "",
                      Unit: listing.street_2 || "",
                      city: listing.city || "",
                      state: listing.state || "",
                      zipcode: listing.zipcode || "",
                      address: `${listing.street || ""} ${listing.street_2 || ""}, ${listing.city || ""}, ${listing.state || ""} ${listing.zipcode || ""}`
                    }} />
                  </div>
                ) : (
                  <div className={styles.addressCaution}>
                    <ErrorIcon className={styles.icon} />
                    <div className={styles.text}>
                      Owner/Agent has opted to hide the exact address!
                    </div>
                  </div>
                )} */}
              </div>

              {/* Action Buttons */}
              <div className={styles.actionButtons}>
                <Button variant="contained" color="primary">
                  Contact Landlord
                </Button>
                <Button variant="outlined" color="secondary">
                  Schedule a Visit
                </Button>
              </div>
            </>
          )}
        </CardContent>

        {/* <div className={styles.listingActions}>
          <IconButton
            aria-label="bookmark"
            variant="plain"
            color="neutral"
            size="sm"
            className={styles.bookmarkButton}
            onClick={(e) => handleBookmarkClick(e, listing.id)}
          >
            <BookmarkAdd />
          </IconButton>
        </div> */}
      </Card>

      {/* Listing Details Modal */}
      <DashListingDetails
        listing={listing}
        detailsModel={detailsModel}
        closeModel={closeModel}
      />
    </>
  );
};

export default DashListingCard;
